export default __webpack_public_path__ + "static/media/R_footer.29d61a53.png";